export default function ArrowDown() {
  return (
    <svg width="18" height="10" viewBox="0 0 18 10" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path fillRule="evenodd" clipRule="evenodd" d="M0.96967 0.46967C1.26256 0.176777 1.73744 0.176777 2.03033 0.46967L9 7.43934L15.9697 0.46967C16.2626 0.176777 16.7374 0.176777 17.0303 0.46967C17.3232 0.762563 17.3232 1.23744 17.0303 1.53033L9.53033 9.03033C9.23744 9.32322 8.76256 9.32322 8.46967 9.03033L0.96967 1.53033C0.676777 1.23744 0.676777 0.762563 0.96967 0.46967Z" fill="#414143"/>
    </svg>
  )
}
